<template>
    <div 
      class="file"
      :style="{
        width: windowSize.width > 700 ? (windowSize.width*0.7 + 'px') : (windowSize.width*0.85 + 'px'),
      }"
    >
        <ReturnIcon
          v-model   = "dataArray"
          :dataArray='fileData'
          :search="searchJudge"
        />

        <div class="text_body">
          <div
            v-if="!textList"
            v-html="dataArray.data"
            class="markdown"
          ></div>

          <div 
            v-if="textList"
            class="text_list"
            v-for="item in dataArray"
          >
            <div
              class="title"
              v-if="item.title"
            >{{ item.title }}</div>

            <pre
              v-if="type == 'jsFs' && item.Introduction"
              class="introduction"
            >{{ item.Introduction }}</pre>

            <pre
              v-if="type == 'regular' && item.Introduction"
              class="introduction_regular"
            >{{ item.Introduction }}</pre>
          </div>

          <div 
            class="text_list"
            v-if="type == 'regular'"
          >
            <div
              class="title"
            >是否html标签</div>

            <pre
              class="introduction_regular"
            >/<(.*)>.*<\/\1>|<(.*) \/>/</pre>
          </div>
          <div 
            class="text_list"
            v-if="type == 'regular'"
          >
            <div
              class="title"
            >日期,如: 2000-01-01</div>

            <pre
              class="introduction_regular"
            >/^\d{4}(-)\d{1,2}\1\d{1,2}$/</pre>
          </div>
        </div>
        
    </div>
</template>

<script>
import Pages   from '../mixins/pages.vue'
import JsFs    from '../mixins/file/jsFs.vue'
import Regular from '../mixins/file/regular.vue'
import VueCli  from '../mixins/file/vueCli.vue'
import Css     from '../mixins/file/css.vue'

export default {
  name: 'file',
  mixins: [Pages, JsFs, Regular, VueCli, Css],
  data (){
    return {
      type     : 'jsFs',
      fileData : [],
      searchJudge : true,
      textList    : true,
    }
  },
  mounted: function () {

    this.type = this.$route.query.type || 'jsFs';
    this.dataArray = this.fileData = this[this.type] || this.jsFs;
    switch(this.type){
      case 'vueCli':
      case 'css':
        this.searchJudge = false;
        this.textList = false;
        break;
      default:
        this.searchJudge = true;
        this.textList = true;
    }

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.file{
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  background: #fff;
  border-radius: 6px 6px 3px 3px;
  padding: 20px 2%;
  margin-bottom: 50px;

  *{
    user-select: text !important;
  }

  .text_body{
    text-align: left;
    width: 100%;

    .text_list{
      padding: 5px 10px;
      margin-bottom: 50px;
      
      .title{

        text-align: left;
        font-size: 22px;
      }

      .introduction_regular,
      .introduction{
        padding: 10px;
        font-size: 15px;
        text-align: left;
        background: #282c34;
        color: #ff9401;
      }

      .introduction_regular{
        padding: 15px;
      }
    }
    .markdown{
      .lang-javascript{
        
      }
    }
  }
}
</style>
